var _ellipse, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 18.7817,
    cy: 19,
    rx: 18.7817,
    ry: 18.5,
    fill: "#EDEDF1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 29.5C11.0125 29.5 10.5417 29.3042 10.15 28.9125C9.75833 28.5208 9.5625 28.05 9.5625 27.5V13.5C9.5625 12.95 9.75833 12.4792 10.15 12.0875C10.5417 11.6958 11.0125 11.5 11.5625 11.5H12.5625V10.5C12.5625 10.2167 12.6583 9.97917 12.85 9.7875C13.0417 9.59583 13.2792 9.5 13.5625 9.5C13.8458 9.5 14.0833 9.59583 14.275 9.7875C14.4667 9.97917 14.5625 10.2167 14.5625 10.5V11.5H22.5625V10.5C22.5625 10.2167 22.6583 9.97917 22.85 9.7875C23.0417 9.59583 23.2792 9.5 23.5625 9.5C23.8458 9.5 24.0833 9.59583 24.275 9.7875C24.4667 9.97917 24.5625 10.2167 24.5625 10.5V11.5H25.5625C26.1125 11.5 26.5833 11.6958 26.975 12.0875C27.3667 12.4792 27.5625 12.95 27.5625 13.5V27.5C27.5625 28.05 27.3667 28.5208 26.975 28.9125C26.5833 29.3042 26.1125 29.5 25.5625 29.5H11.5625ZM11.5625 27.5H25.5625V17.5H11.5625V27.5Z",
    fill: "#585F71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarCircle);
export default __webpack_public_path__ + "static/media/calendar-circle.fe1fb900e8ac00dc32585ac7155b263c.svg";
export { ForwardRef as ReactComponent };